// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"8bc54b31","222":"8050c066","510":"b9681a0f","957":"bc567b21"}[chunkId] + ".chunk.js";
};